import * as React from 'react';

function Quote(props) {
  return (
    <svg
      width={16}
      height={12}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.85 0.23999H10.25C9.50467 0.23999 8.89999 0.792845 8.89999 1.47427V4.76569C8.89999 5.44711 9.50467 5.99997 10.25 5.99997H12.5V7.64567C12.5 8.55338 11.6928 9.29138 10.7 9.29138H10.475C10.1009 9.29138 9.79999 9.56652 9.79999 9.90852V11.1428C9.79999 11.4848 10.1009 11.7599 10.475 11.7599H10.7C13.1862 11.7599 15.2 9.91881 15.2 7.64567V1.47427C15.2 0.792845 14.5953 0.23999 13.85 0.23999ZM5.74999 0.23999H2.14999C1.40468 0.23999 0.799988 0.792845 0.799988 1.47427V4.76569C0.799988 5.44711 1.40468 5.99997 2.14999 5.99997H4.39999V7.64567C4.39999 8.55338 3.5928 9.29138 2.59999 9.29138H2.37499C2.00093 9.29138 1.69999 9.56652 1.69999 9.90852V11.1428C1.69999 11.4848 2.00093 11.7599 2.37499 11.7599H2.59999C5.08624 11.7599 7.09999 9.91881 7.09999 7.64567V1.47427C7.09999 0.792845 6.4953 0.23999 5.74999 0.23999Z"
        fill="#2A2E31"
      />
    </svg>
  );
}

export default Quote;
